export const tariffCollectionGuard = 'GET /tariffs';
export const tariffsResourceGuard = 'GET /tariffs/d+';
export const addTariffsResourceGuard = 'POST /tariffs';
export const editTariffsResourceGuard = 'PUT /tariffs/d+';
export const deleteTariffsResourceGuard = 'DELETE /tariffs/d+';
